import styled from 'styled-components'

export const CheckboxAndRadioWrapper = styled.div`
  display: grid;
  grid-template-rows: ${({ gridTemplateRows }) =>
    `repeat(${gridTemplateRows}, 0fr)`};

  grid-template-columns: max-content auto;
  column-gap: 20px;
  row-gap: 16px;
  grid-auto-flow: column;
`
